import { fetchFinance } from "utils/api";

export const queryList = async (params) => {
  return await fetchFinance("/settlement/list", {
    status: "WAITING",
    type: "pending",
    sort: "tran_date,desc",
    ...params,
  });
};

export const updateServiceFee = async (params) => {
  return await fetchFinance("/action", {
    action: "updateServiceFee",
    ...params,
  });
};

export const updateAll = async (params) => {
  return await fetchFinance("/action", {
    action: "approve",
    updateBankAccount: true,
    ...params,
  });
};

export const approveOrRejectPlan = async (params) => {
  return await fetchFinance("/action", {
    action: "approve",
    ...params,
  });
};
